(function () {
  'use strict';

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-company-reviews]'));
  if (!roots.length) return;
  var themeConfig = window.CrownThemeConfig || {};
  var staticConfig = window.CROWN_STORE_CONFIG || {};
  var serviceBase = String(themeConfig.schoolServiceBase || staticConfig.serviceBaseUrl || '').replace(/\/$/, '');
  var localPreview = /^(127\.0\.0\.1|localhost)$/.test(location.hostname) || location.protocol === 'file:';
  var REVIEW_ROTATION_MS = 15000;
  var previewReviews = [
    { id: 'preview-1', name: 'Preview customer', rating: 5, review: 'The whole experience feels considered, from ordering through to the way the container looks at home.', product: 'Luxe Linen Laundry Pods', location: 'Auckland', verified: true, featured: true, submittedAt: '2026-08-22T00:00:00Z' },
    { id: 'preview-2', name: 'Preview customer', rating: 5, review: 'Simple to use, beautifully presented and reliably clean. It has made an everyday routine feel much calmer.', product: 'Crystal Shine Dishwasher Pods', location: 'Waikato', verified: true, featured: true, submittedAt: '2026-08-18T00:00:00Z' },
    { id: 'preview-3', name: 'Preview customer', rating: 4, review: 'The refill system is straightforward and the packaging is something I am happy to keep in view.', product: 'Cherry Blossom Refill', location: 'Wellington', verified: false, featured: true, submittedAt: '2026-08-12T00:00:00Z' },
    { id: 'preview-4', name: 'Preview customer', rating: 5, review: 'The pods are easy to use and the reusable container makes the laundry feel beautifully organised.', product: 'Cherry Blossom Laundry Pods', location: 'Canterbury', verified: true, featured: true, submittedAt: '2026-08-08T00:00:00Z' },
    { id: 'preview-5', name: 'Preview customer', rating: 5, review: 'The dishwasher pods leave everything clean without residue, and ordering a refill could not be simpler.', product: 'Crystal Shine Refill', location: 'Bay of Plenty', verified: true, featured: true, submittedAt: '2026-08-04T00:00:00Z' },
    { id: 'preview-6', name: 'Preview customer', rating: 5, review: 'From the thoughtful packaging to the fresh result, the whole experience feels genuinely premium.', product: 'Luxe Linen Refill', location: 'Otago', verified: false, featured: true, submittedAt: '2026-08-01T00:00:00Z' }
  ];
  var state = { reviews: [], summary: { average: 0, count: 0, distribution: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 } } };

  function service(path) { return serviceBase ? serviceBase + path : path; }
  function stars(rating) { return '★★★★★'.slice(0, rating) + '☆☆☆☆☆'.slice(0, 5 - rating); }
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function formatMonth(value) {
    try { return new Intl.DateTimeFormat('en-NZ', { month: 'long', year: 'numeric' }).format(new Date(value)); }
    catch (_) { return ''; }
  }
  function previewEnabled(root) { return localPreview && root.getAttribute('data-review-preview') === 'true'; }

  function summaryFor(reviews) {
    var distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    reviews.forEach(function (review) { distribution[review.rating] += 1; });
    var count = reviews.length;
    var average = count ? reviews.reduce(function (sum, review) { return sum + review.rating; }, 0) / count : 0;
    return { average: Math.round(average * 10) / 10, count: count, distribution: distribution };
  }

  function reviewCard(review, compact) {
    var article = element('article', compact ? 'company-review company-review--compact' : 'company-review');
    var top = element('div', 'company-review__top');
    var starNode = element('span', 'company-review__stars', stars(review.rating));
    starNode.setAttribute('aria-label', review.rating + ' out of 5 stars');
    top.appendChild(starNode);
    if (review.verified) {
      var badge = element('span', 'company-review__verified', 'Verified purchase');
      badge.title = 'Submitted through a private link connected to a fulfilled Crown Standard order.';
      top.appendChild(badge);
    }
    article.appendChild(top);
    article.appendChild(element('blockquote', 'company-review__copy', '“' + review.review + '”'));
    var footer = element('footer', 'company-review__meta');
    footer.appendChild(element('strong', '', review.name));
    if (review.location) footer.appendChild(element('span', '', review.location));
    if (review.product) footer.appendChild(element('span', 'company-review__product', review.product));
    if (!compact && review.submittedAt) footer.appendChild(element('time', '', formatMonth(review.submittedAt)));
    article.appendChild(footer);
    return article;
  }

  function initReviewRotation(list, reviews, compact) {
    var offset = 0;
    var changing = false;

    function paint() {
      list.replaceChildren(reviewCard(reviews[offset], compact));
    }

    paint();
    if (reviews.length <= 1) return;
    window.setInterval(function () {
      if (changing) return;
      changing = true;
      list.classList.add('is-rotating');
      window.setTimeout(function () {
        offset = (offset + 1) % reviews.length;
        paint();
        list.classList.remove('is-rotating');
        changing = false;
      }, 360);
    }, REVIEW_ROTATION_MS);
  }

  function renderHome(root) {
    var list = root.querySelector('[data-review-list]');
    var reviews = state.reviews;
    if (!reviews.length) { root.hidden = true; return; }
    initReviewRotation(list, reviews, true);
    var summary = root.querySelector('[data-review-summary-copy]');
    if (summary) summary.textContent = state.summary.average.toFixed(1) + ' from ' + state.summary.count + ' customer review' + (state.summary.count === 1 ? '' : 's');
    root.hidden = false;
  }

  function renderSummary(root) {
    var starNode = root.querySelector('[data-review-summary-stars]');
    root.querySelectorAll('[data-review-summary-copy]').forEach(function (summary) {
      summary.textContent = state.summary.count
        ? state.summary.average.toFixed(1) + ' from ' + state.summary.count + ' review' + (state.summary.count === 1 ? '' : 's')
        : 'No customer reviews yet';
    });
    if (starNode) { starNode.textContent = state.summary.count ? stars(Math.round(state.summary.average)) : 'No ratings yet'; starNode.setAttribute('aria-label', state.summary.count ? state.summary.average.toFixed(1) + ' out of 5 stars' : 'No ratings yet'); }
  }

  function renderPage(root) {
    renderSummary(root);
    var list = root.querySelector('[data-review-list]');
    var listSection = list.parentElement;
    var empty = root.querySelector('[data-review-empty]');
    if (state.reviews.length) {
      listSection.hidden = false;
      empty.hidden = true;
      initReviewRotation(list, state.reviews, false);
    } else {
      listSection.hidden = false;
      list.replaceChildren();
      empty.hidden = false;
    }
    root.hidden = false;
  }

  function load() {
    var isPreview = roots.some(previewEnabled);
    if (isPreview) {
      state.reviews = previewReviews;
      state.summary = summaryFor(previewReviews);
      roots.forEach(function (root) { root.setAttribute('data-review-preview-active', 'true'); root.querySelector('[data-review-preview-note]')?.removeAttribute('hidden'); });
      return Promise.resolve();
    }
    return fetch(service('/api/reviews'), { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Reviews unavailable');
      return response.json();
    }).then(function (payload) {
      state.reviews = Array.isArray(payload.reviews) ? payload.reviews : [];
      state.summary = payload.summary || summaryFor(state.reviews);
    });
  }

  function initForm(root) {
    var dialog = root.querySelector('[data-review-dialog]');
    var form = root.querySelector('[data-review-form]');
    if (!dialog || !form) return;
    root.querySelectorAll('[data-review-open]').forEach(function (button) { button.addEventListener('click', function () { dialog.showModal(); }); });
    root.querySelector('[data-review-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    var status = form.querySelector('[data-review-form-status]');
    var invite = new URLSearchParams(location.search).get('invite') || '';
    if (invite && !previewEnabled(root)) {
      fetch(service('/api/reviews/invite?token=' + encodeURIComponent(invite)), { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : { valid: false }; })
        .then(function (payload) {
          var badge = form.querySelector('[data-review-invite-badge]');
          if (payload.valid) {
            badge.hidden = false;
            if (payload.product) form.elements.product.value = payload.product;
            dialog.showModal();
          } else { status.textContent = 'This private review link has already been used or is no longer available. You can still leave an unverified review.'; }
        }).catch(function () { status.textContent = 'We could not verify the private link right now. You can still leave an unverified review.'; });
    } else if (location.hash === '#leave-review') {
      dialog.showModal();
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      if (previewEnabled(root)) { status.textContent = 'Preview only — no review was submitted and no live data changed.'; return; }
      var button = form.querySelector('button[type="submit"]'); button.disabled = true; status.textContent = 'Preparing your review…';
      fetch(service('/api/reviews'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          name: form.elements.name.value, rating: form.elements.rating.value, review: form.elements.review.value,
          product: form.elements.product.value, location: form.elements.location ? form.elements.location.value : '',
          website: form.elements.website.value, invite: invite
        })
      }).then(function (response) { return response.json().then(function (payload) { if (!response.ok) throw new Error(payload.error || 'The review could not be saved.'); return payload; }); })
        .then(function (payload) { form.reset(); status.textContent = payload.message; form.querySelector('.company-review-form__fields').hidden = true; button.hidden = true; })
        .catch(function (error) { status.textContent = error.message; button.disabled = false; });
    });
  }

  load().then(function () {
    roots.forEach(function (root) {
      var surface = root.getAttribute('data-review-surface');
      if (surface === 'home') renderHome(root);
      if (surface === 'page') { initForm(root); renderPage(root); }
    });
  }).catch(function () {
    roots.forEach(function (root) {
      if (root.getAttribute('data-review-surface') === 'home') root.hidden = true;
      else { root.hidden = false; root.querySelector('[data-review-load-error]').hidden = false; }
    });
  });
}());
